import { render } from "./ModalUser.vue?vue&type=template&id=3bb2f643&lang=pug"
import script from "./ModalUser.vue?vue&type=script&lang=js"
export * from "./ModalUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__